import { Directive, ElementRef, forwardRef, HostListener, inject, Renderer2 } from '@angular/core';
import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: 'input[tdToUppercase]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToUppercaseDirective),
      multi: true,
    },
  ],
})
export class ToUppercaseDirective extends DefaultValueAccessor {
  constructor() {
    super(inject(Renderer2), inject(ElementRef), false);
  }

  @HostListener('input', ['$event'])
  input($event: Event): void {
    const target = $event.target as HTMLInputElement;
    const start = target.selectionStart;

    target.value = target.value.toUpperCase();
    target.setSelectionRange(start, start);

    this.onChange(target.value);
  }
}
